import { render, staticRenderFns } from "./AddOthersModal.vue?vue&type=template&id=942575f2&"
import script from "./AddOthersModal.vue?vue&type=script&lang=js&"
export * from "./AddOthersModal.vue?vue&type=script&lang=js&"
import style0 from "./AddOthersModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports